import React from 'react'
import "./OccupiedStagging.css"
import { useNavigate } from 'react-router-dom';


function CardOS({
    title="",
    content="",
    lightTheme,
    fourBox=false,
    contentHtml=false,
    contentHeight=false
}){
    const paragraphs = content.split('\n').map((paragraph, index) => <p key={index} className={`body-paragraph my-1 mb-3 ${lightTheme?"color-dark" :"color-light"}`}>{paragraph}</p>);
    return(
        <div className={`card-box p-5 ${fourBox && "px-4"}`}
            style={lightTheme?{border:"1px solid black"}:{border:"1px solid white"}}
        >
            <div className='d-flex flex-column gap-3 text-center justify-content-center align-items-center h-100'>
                {title && <h5 className={`sub-heading ${lightTheme?"color-dark" :"color-light"} mb-1`}>{title}</h5>}
                {
                    contentHtml?
                    <p className={`body-paragraph ${lightTheme?"color-dark" :"color-light"} ${contentHeight?"":"card-para"}`} dangerouslySetInnerHTML={{__html:content}}></p>
                    :
                    <p className={`body-paragraph ${lightTheme?"color-dark" :"color-light"} card-para`}>{paragraphs}</p>
                }
            </div>
        </div>
    )
}

function OccupiedStagging({
    subHeading='',
    heading="",
    content="",
    contentTopHtml=false,
    card1={
      title:"",
      content:""
    },
    card2={
      title:"",
      content:""
    },
    card3={
      title:"",
      content:""
    },
    card4=null,
    lightTheme=false,
    contentHtml=false,
    contentHeight=false,
    hideBtn=false,
    textCenter=false
}) {
    const navigate = useNavigate()
  return (
    <div 
        className='OccupiedStagging-container '
        style={lightTheme ? {background:"white"}:{background:"black"}}
    
    >
        <div className={`${!lightTheme && "left-gradient-upper"} standard-padding-space`}>
        <div className='container my-4'>

            <div className='text-content'>
                <div className='row gy-3 align-items-center'>
                    <div className={`${textCenter ? "col-lg-12 text-center" :"col-lg-6 "}`}>
                        {subHeading && <h5 className={`sub-heading ${lightTheme ? "color-dark":"color-light"}`}>{subHeading}</h5>}
                        <h3 className={`body-heading ${lightTheme?"color-dark" :"color-light"}`} >{heading}</h3>
                        <p className={`body-paragraph  my-4 ${lightTheme?"color-dark" :"color-light"}`}>{content}</p>
                        {contentTopHtml && <p className='' dangerouslySetInnerHTML={{__html:contentTopHtml}}></p>}
                    </div>
                    {
                        !hideBtn &&
                        <div className='col-lg-6 text-center text-lg-end my-3 my-lg-0'>
                            <button className={`${lightTheme?"genral-btn-light":"genral-btn"} `} onClick={()=>{navigate("/get-a-quote")}}>Get A QUOTE</button>
                        </div>
                    }
                </div>
            </div>

            <div className='card-container'>
                <div className='row gy-4 mt-4'>
                <div className={` ${card4? "col-lg-3":"col-lg-4"} `}>
                        <CardOS
                            title={card1.title}
                            content={card1.content}
                            lightTheme={lightTheme}
                            fourBox={card4}
                            contentHtml={contentHtml}
                            contentHeight={contentHeight}
                        />
                    </div>
                    <div className={` ${card4? "col-lg-3":"col-lg-4"} `}>
                        <CardOS
                             title={card2.title}
                             content={card2.content}
                             lightTheme={lightTheme}
                             fourBox={card4}
                            contentHtml={contentHtml}
                            contentHeight={contentHeight}
                        />
                    </div>
                    <div className={` ${card4? "col-lg-3":"col-lg-4"} `}>
                        <CardOS
                             title={card3.title}
                             content={card3.content}
                             lightTheme={lightTheme}
                             fourBox={card4}
                            contentHtml={contentHtml}
                            contentHeight={contentHeight}
                        />
                    </div>
                    {
                        card4 && 
                        <div className='col-lg-3'>
                            <CardOS
                                title={card4.title}
                                content={card4.content}
                                lightTheme={lightTheme}
                                fourBox={card4}
                                contentHtml={contentHtml}
                                contentHeight={contentHeight}
                            />
                        </div>
                    }

                </div>

            </div>
        </div>
        </div>
    </div>
  )
}

export default OccupiedStagging